module.exports = __webpack_public_path__ + "img/policy-2.c8d1077a.png";